// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"d5233ef800813896399f","132":"4792b0c4b2bff9de436b","133":"ee2fa57f1bd7a36ff5af","171":"f9ab52e2e0d1f911a420"}[chunkId] + ".chunk.js";
};